import React from 'react'
import { Link } from 'react-router-dom'

export default props => {
  const {
    className,
    ...rest
  } = props

  return (
    <Link {...rest}
      className={`fw5 norms-12 norms-ttu no-underline underline-hover ${className}`}
    />
  )
}
